import { ref } from 'vue'
import type { MenuItem } from '@groveco/http-services'

import { createSharedComposable } from '~/composables/utils/createSharedComposable'

/**
 * Produces a shared ref for navigational menu items
 *
 * Note: This composable does not automatically load menuItems
 * on instantiation. This is because it is written to be used
 * in conjunction with useAsyncData() such that the fetch only
 * happens once, server-side.
 *
 * @see: https://nuxt.com/docs/api/composables/use-async-data
 * @see: https://content.nuxt.com/composables/query-content#important-%EF%B8%8F
 */
export default createSharedComposable(() => {
  const menuItems = ref<Array<MenuItem>>([])

  const fetchMenuItems = async () => {
    const menu = await queryContent('menu')
      .where({ menuItems: { $exists: true } })
      .findOne()
    return menu.menuItems
  }

  const setMenuItems = (value: Array<MenuItem>) => {
    menuItems.value = value
  }

  return {
    /**
     * Ref for menu items. Will only contain the actual data after fetch and
     * set calls have been made. */
    menuItems,
    /** Method to fetch menu items. */
    fetchMenuItems,
    /** Method to set menu items. */
    setMenuItems,
  }
})
